import * as core from '../../../../../../../core'
import * as attainSpecKit from '../attain-spec-kit'

export const RESOURCE = {
  payload: {
    alias: 'testing',
    appAlias: attainSpecKit.RESOURCE.payload.alias,
    description:
      'Review test and deployment results for implementation pull requests',
    display: {
      isMain: true,
      position: 4,
    },
    name: 'Testing',
    page: { alias: 'testing' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
